// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__L7skZ","rotate":"loader_rotate__Y_wfI","spinner-animation":"loader_spinner-animation__y3Jlg"};